const isAuthUser = (to, from, next) => {
  this.$store.dispatch('getUserInfo').then(() => {
    if (this.$store.state.isLogin === false) {
      alert('로그인이 필요한 메뉴입니다.')
      next('/Login')
    } else {
      next()
    }
  })
}

exports.ROUTES = {
  mode: 'history',
  base: '/',
  routes: [
  {
    path: '/wiznft',
    name: 'Wiznft',
    component: () =>
      import(/* webpackChunkName: "NftHome" */ '@/view/nft/Home')
  },
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "Home" */ '@/view/Selling')
  },
  {
    path: '/demo',
    name: 'DemoHome',
    component: () =>
      import(/* webpackChunkName: "DemoHome" */ '@/view/Home')
  },
  {
    path: '/Store',
    name: 'Store',
    component: () =>
      import(/* webpackChunkName: "Store" */ '@/view/Store')
  },
  {
    path: '/Contents/:contentsSysId',
    name: 'Contents',
    component: () =>
      import(/* webpackChunkName: "Contents" */ '@/view/menu/ContentDtl')
  },
  {
    path: '/Vod/:broadcastSysId/:broadcastScheduleSysId',
    name: 'HomeVod',
    component: () =>
      import(/* webpackChunkName: "HomeVod" */ '@/view/Home')
  },
  {
    path: '/Vod/:broadcastSysId/:broadcastScheduleSysId/:type',
    name: 'HomeLive',
    component: () =>
      import(/* webpackChunkName: "HomeVod" */ '@/view/Home')
  },
  {
    path: '/category/:category/:subCategory',
    name: 'Category',
    component: () =>
      import(/* webpackChunkName: "Category" */ '@/view/subpage/Fashion/FashionMain')
  },
  {
    path: '/Planning/:type/:brandSysId',
    name: 'Planning',
    component: () =>
      import(/* webpackChunkName: "Planning" */ '@/view/planning/Planning')
  },
  {
    path: '/PlanningEvent/:planSysId',
    name: 'PlanningEvent',
    component: () =>
      import(/* webpackChunkName: "PlanningEvent" */ '@/view/planning/Planning2')
  },
  {
    path: '/PlanningEvent/:planSysId/:flag',
    name: 'PlanningEventSub',
    component: () =>
      import(/* webpackChunkName: "PlanningEventSub" */ '@/view/planning/Planning2')
  },
  {
    path: '/Product/:prdtSysId',
    name: 'ProductDetail',
    component: () =>
      import(/* webpackChunkName: "ProductDetail" */ '@/view/ProductDetail/ProductDetailMain')
  },
  {
    path: '/Product/:prdtSysId/:planPrdtSysId',
    name: 'ProductPlan',
    component: () =>
      import(/* webpackChunkName: "ProductDetailPlan" */ '@/view/ProductDetail/ProductDetailMain')
  },
  {
    path: '/Product/:prdtSysId/Live/:broadcastScheduleSysId',
    name: 'ProductDetailLive',
    component: () =>
      import(/* webpackChunkName: "ProductDetailLive" */ '@/view/ProductDetail/ProductDetailMain')
  },
  {
    path: '/ProductQa/:prdtSysId',
    name: 'ProductQna',
    component: () =>
      import(/* webpackChunkName: "ProductQa" */ '@/view/ProductDetail/ProductQa')
  },
  {
    path: '/Binding/:prdtSysId',
    name: 'BindingProduct',
    component: () =>
      import(/* webpackChunkName: "BindingProducts" */ '@/view/ProductDetail/bindingPrdtList')
  },
  {
    path: '/Login',
    name: 'Login',
    // beforeEnter: rejectAuthUser,
    component: () =>
      import(/* webpackChunkName: "Login" */ '@/view/member/Login')
  },
  {
    path: '/RegStep04',
    name: 'RegStep04',
    component: () =>
      import(/* webpackChunkName: "RegStep04" */ '@/view/member/RegStep04')
  },
  {
    path: '/About',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "About" */ '@/view/menu/About')
  },
  {
    path: '/About/Terms',
    name: 'TermsAll',
    component: () =>
      import(/* webpackChunkName: "TermsAll" */ '@/view/menu/TermsService')
  },
  {
    path: '/About/Privacy',
    name: 'Priavte',
    component: () =>
      import(/* webpackChunkName: "Priavte" */ '@/view/menu/Privacy')
  },
  {
    path: '/search',
    name: 'Search',
    component: () =>
      import(/* webpackChunkName: "Search" */ '@/view/search/SearchPage')
  },
  {
    path: '/Searchid',
    name: 'Searchid',
    component: () =>
      import(/* webpackChunkName: "Searchid" */ '@/view/member/Searchid')
  },
  {
    path: '/Searchpw',
    name: 'Searchpw',
    component: () =>
      import(/* webpackChunkName: "Searchpw" */ '@/view/member/Searchpw')
  },
  {
    path: '/SearchpwSet',
    name: 'SearchpwSet',
    component: () =>
      import(/* webpackChunkName: "SearchpwSet" */ '@/view/member/SearchpwSet')
  },
  {
    path: '/RegStep00',
    name: 'RegStep00',
    component: () =>
      import(/* webpackChunkName: "RegStep00" */ '@/view/member/RegStep00')
  },
  {
    path: '/Terms/:num',
    name: 'Terms',
    component: () =>
      import(/* webpackChunkName: "Terms" */ '@/view/member/Terms')
  },
  {
    path: '/MyPage',
    name: 'MyPage',
    beforeEach: {
      isAuthUser
    },
    component: () =>
      import(/* webpackChunkName: "MyPage" */ '@/view/mypage/MainPage')
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: () =>
      import(/* webpackChunkName: "Notice" */ '@/view/mypage/Notice')
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "Contact" */ '@/view/mypage/Contact')
  },
  {
    path: '/Tracking',
    name: 'Tracking',
    component: () =>
      import(/* webpackChunkName: "Tracking" */ '@/view/mypage/Tracking')
  },
  {
    path: '/Tracking/delivery',
    name: 'TrackingDelivery',
    component: () =>
      import(/* webpackChunkName: "TrackingDelivery" */ '@/view/mypage/TrackingDetail')
  },
  {
    path: '/Tracking/:orderSysId/:orderPrdtSysId',
    name: 'TrackingDetail',
    component: () =>
      import(/* webpackChunkName: "TrackingDetail" */ '@/view/mypage/TrackingDetail')
  },
  {
    path: '/BuyProduct',
    name: 'BuyProduct',
    component: () =>
      import(/* webpackChunkName: "BuyProduct" */ '@/view/buyProduct/BuyPageMain')
  },
  {
    path: '/BuyProduct/searchPost',
    name: 'searchPost',
    component: () =>
      import(/* webpackChunkName: "searchPost" */ '@/components/buypage/Modal/DaumPostWindow')
  },
  {
    path: '/BuyComplete',
    name: 'BuyComplete',
    component: () =>
      import(/* webpackChunkName: "BuyComplete" */ '@/view/buyProduct/BuyComplete')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () =>
      import(/* webpackChunkName: "Cart" */ '@/view/cart/CartMain')
  },
  {
    path: '/cartOrder',
    name: 'CartOrder',
    component: () =>
      import(/* webpackChunkName: "CartOrder" */ '@/view/cart/CartOrder')
  },
  {
    path: '/nonMemberOrder',
    name: 'NonMemberOrder',
    component: () =>
      import(/* webpackChunkName: "NonMemberOrder" */ '@/view/nonMemberOrderSearch/NonMemberOrder')
  },
  {
    path: '/modifyProfile',
    name: 'ModifyProfile',
    component: () =>
      import(/* webpackChunkName: "ModifyProfile" */ '@/view/mypage/ModifyProfile')
  },
  {
    path: '/Coupon',
    name: 'Coupon',
    component: () =>
      import(/* webpackChunkName: "Coupon" */ '@/view/mypage/Coupon')
  },
  {
    path: '/AlertList',
    name: 'AlertList',
    component: () =>
      import(/* webpackChunkName: "AlertList" */ '@/view/mypage/AlertList')
  },
  {
    path: '/AlertSet',
    name: 'AlertSet',
    component: () =>
      import(/* webpackChunkName: "AlertSet" */ '@/view/mypage/AlertSet')
  },
  {
    path: '/VersionChk',
    name: 'VersionChk',
    component: () =>
      import(/* webpackChunkName: "VersionChk" */ '@/view/mypage/VersionChk')
  },
  {
    path: '/ChangePw',
    name: 'ChangePw',
    component: () =>
      import(/* webpackChunkName: "ChangePw" */ '@/view/mypage/ChangePw')
  },
  {
    path: '/ChkPw',
    name: 'ChkPw',
    component: () =>
      import(/* webpackChunkName: "ChkPw" */ '@/view/mypage/ChkPw')
  },
  {
    path: '/Exchange',
    name: 'Exchange',
    component: () =>
      import(/* webpackChunkName: "Exchange" */ '@/view/mypage/Exchange')
  },
  {
    path: '/ExchangeDetail/:orderSysId',
    name: 'ExchangeDetail',
    component: () =>
      import(/* webpackChunkName: "ExchangeDetail" */ '@/view/mypage/ExchangeDetail')
  },
  {
    path: '/ExchangeDetail/:orderSysId/:orderPrdtSysId',
    name: 'ExchangeDetailMore',
    component: () =>
      import(/* webpackChunkName: "ExchangeDetailMore" */ '@/view/mypage/ExchangeDetail')
  },
  {
    path: '/ExchangeDetail/:orderSysId/:orderPrdtSysId/:sysId/:reqType',
    name: 'ExchangeDetailMoreReq',
    component: () =>
      import(/* webpackChunkName: "ExchangeDetailMoreCancel" */ '@/view/mypage/ExchangeDetail')
  },
  {
    path: '/BuyHistory',
    name: 'BuyHistory',
    component: () =>
      import(/* webpackChunkName: "BuyHistory" */ '@/view/mypage/BuyHistory')
  },
  {
    path: '/Basket',
    name: 'Basket',
    component: () =>
      import(/* webpackChunkName: "Basket" */ '@/view/mypage/Basket')
  },
  {
    path: '/ViewLog',
    name: 'ViewLog',
    meta: {
      authRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "ViewLog" */ '@/view/mypage/ViewLog')
  },
  {
    path: '/MyReview',
    name: 'MyReview',
    component: () =>
      import(/* webpackChunkName: "MyReview" */ '@/view/mypage/MyReview')
  },
  {
    path: '/ExchangeReq/:orderSysId/:orderPrdtSysId/:type',
    name: 'ExchangeReqType',
    component: () =>
      import(/* webpackChunkName: "ExchangeReq" */ '@/view/mypage/ExchangeReq')
  },
  {
    path: '/reqPay/:orderSysId/:orderPrdtSysId',
    name: 'RequestDeliveryPay',
    component: () =>
      import(/* webpackChunkName: "ExchangeReq" */ '@/view/mypage/ExchangePay')
  },
  {
    path: '/reqPayComplete/:orderSysId/:orderPrdtSysId',
    name: 'RequestDeliveryPayComplete',
    component: () =>
      import(/* webpackChunkName: "ExchangeReq" */ '@/view/mypage/ExchangePayComplete')
  },
  {
    path: '/ExchangeReq/:orderSysId/',
    name: 'ExchangeReq',
    component: () =>
      import(/* webpackChunkName: "ExchangeReq" */ '@/view/mypage/ExchangeReq')
  },
  {
    path: '/CancelReq/:orderSysId/:orderPrdtSysId',
    name: 'PrdtCancelReq',
    component: () =>
      import(/* webpackChunkName: "CancleReq" */ '@/view/mypage/CancleReq')
  },
  {
    path: '/CancelReq/:orderSysId',
    name: 'CancelReq',
    component: () =>
      import(/* webpackChunkName: "CancleReq" */ '@/view/mypage/CancleReq')
  },
  {
    path: '/ExchangeInvoice/:orderSysId/:orderPrdtSysId',
    name: 'ExchangeInvoice',
    component: () =>
      import(/* webpackChunkName: "CancleReq" */ '@/view/mypage/ExchangeInvoice')
  },
  {
    path: '/ReviewWrite/:prdtSysId/:orderSysId/:orderPrdtSysId',
    name: 'ReviewWrite',
    component: () =>
      import(/* webpackChunkName: "ReviewWrite" */ '@/view/mypage/ReviewWrite')
  },
  {
    path: '/ReviewWrite/:prdtSysId/:orderSysId/:orderPrdtSysId/:type',
    name: 'MonthReviewWrite',
    component: () =>
      import(/* webpackChunkName: "MonthReviewWrite" */ '@/view/mypage/ReviewWrite')
  },
  {
    path: '/ReviewModify/:prdtSysId/:prdtReviewSysId/:type',
    name: 'ReviewModify',
    component: () =>
      import(/* webpackChunkName: "ReviewModify" */ '@/view/mypage/ReviewWrite')
  },
  {
    path: '/ReviewList/:prdtSysId',
    name: 'ReviewList',
    component: () =>
      import(/* webpackChunkName: "ReviewList" */ '@/view/ProductDetail/ReviewList')
  },
  {
    path: '/ReviewDetail/:prdtSysId/:prdtReviewSysId',
    name: 'ReviewDetail',
    component: () =>
      import(/* webpackChunkName: "ReviewDetail" */ '@/view/ProductDetail/ReviewDetail')
  },
  {
    path: '/ReviewDetail/:prdtSysId/:prdtReviewSysId/:type',
    name: 'ReviewDetailAll',
    component: () =>
      import(/* webpackChunkName: "ReviewDetailAll" */ '@/view/ProductDetail/ReviewDetail')
  },
  {
    path: '/MypageSetting',
    name: 'MypageSetting',
    component: () =>
      import(/* webpackChunkName: "MypageSetting" */ '@/view/mypage/MypageSetting')
  },
  {
    path: '/ReportLog',
    name: 'ReportLog',
    component: () =>
      import(/* webpackChunkName: "ReportLog" */ '@/view/mypage/ReportLog')
  },
  {
    path: '/SanctionLog',
    name: 'SanctionLog',
    component: () =>
      import(/* webpackChunkName: "SanctionLog" */ '@/view/mypage/SanctionLog')
  },
  {
    path: '/MovieSetting',
    name: 'MovieSetting',
    component: () =>
      import(/* webpackChunkName: "MovieSetting" */ '@/view/mypage/MovieSetting')
  },
  {
    path: '/Privacy',
    name: 'Privacy',
    component: () =>
      import(/* webpackChunkName: "Privacy" */ '@/view/menu/Privacy')
  },
  {
    path: '/TermsService',
    name: 'TermsService',
    component: () =>
      import(/* webpackChunkName: "TermsService" */ '@/view/menu/TermsService')
  },
  {
    path: '/Withdraw',
    name: 'Withdraw',
    component: () =>
      import(/* webpackChunkName: "Withdraw" */ '@/view/member/Withdraw')
  },
  {
    path: '/Calendar',
    name: 'Calendar',
    component: () =>
      import(/* webpackChunkName: "Calendar" */ '@/view/calendar/Calendar')
  },
  {
    path: '/CalendarReserved',
    name: 'CalendarReserved',
    component: () =>
      import(/* webpackChunkName: "CalendarReserved" */ '@/view/calendar/CalendarReserved')
  },
  {
    path: '/MyPoint',
    name: 'MyPoint',
    component: () =>
      import(/* webpackChunkName: "MyPoint" */ '@/view/mypage/MyPoint')
  },
  {
    path: '/MyPointNoti',
    name: 'MyPointNoti',
    component: () =>
      import(/* webpackChunkName: "MyPoint" */ '@/view/mypage/MyPointNoti')
  },
  {
    path: '/CustomerMain',
    name: 'CustomerMain',
    component: () =>
      import(/* webpackChunkName: "CustomerMain" */ '@/view/customer/CustomerMain')
  },
  {
    path: '/myQna',
    name: 'myQna',
    component: () =>
      import(/* webpackChunkName: "myQna" */ '@/view/customer/myQna')
  },
  {
    path: '/WriteQna',
    name: 'WriteQna',
    component: () =>
      import(/* webpackChunkName: "WriteQna" */ '@/view/customer/WriteQna')
  },
  {
    path: '/VersionInfo',
    name: 'Version',
    component: () =>
      import(/* webpackChunkName: "Version" */ '@/view/mypage/VersionInfo')
  },
  {
    path: '/CustomerSearch/:faqKeyword',
    name: 'CustomerSearch',
    component: () =>
      import(/* webpackChunkName: "CustomerSearch" */ '@/view/customer/CustomerSearch')
  },
  {
    path: '/CustomerSearch/:type/:code',
    name: 'CustomerSearchType',
    component: () =>
      import(/* webpackChunkName: "CustomerSearchType" */ '@/view/customer/CustomerSearch')
  },
  {
    path: '/RecieveCors/:corsNum',
    name: 'recieveCors',
    component: () =>
      import(/* webpackChunkName: "recieveCors" */ '@/view/member/infoRecieveCors')
  },
  {
    path: '/PastVod/:broadcastSysId/:broadcastScheduleSysId',
    name: 'pastBroadCast',
    component: () =>
      import(/* webpackChunkName: "pastBroadCast" */ '@/view/liveInfo/PastVod')
  },
  {
    path: '/Live/:broadcastSysId/:broadcastScheduleSysId',
    name: 'Broadcast',
    component: () =>
      import(/* webpackChunkName: "pastBroadCast" */ '@/view/liveInfo/LivePlayer')
  },
  {
    path: '/seller/broadCastDetail/:broadcastSysId/:broadcastScheduleSysId',
    name: 'sellerBroadCastDetail',
    component: () =>
      import(/* webpackChunkName: "sellerBroadCastDetail" */ '@/view/seller/sellerBroadCastDetail')
  },
  {
    path: '/seller/streamTerm/:broadcastSysId/:broadcastScheduleSysId',
    name: 'streamTerm',
    component: () =>
      import(/* webpackChunkName: "streamTerm" */ '@/view/seller/streamTerm')
  },
  {
    path: '/seller/streamSelect/:broadcastSysId/:broadcastScheduleSysId',
    name: 'streamStart',
    component: () =>
      import(/* webpackChunkName: "streamStart" */ '@/view/seller/streamSelect')
  },{
    path: '/seller/intro',
    name: 'sellerIntro',
    component: () =>
      import(/* webpackChunkName: "sellerIntro" */ '@/view/seller/sellerIntro')
  },{
    path: '/seller/join',
    name: 'sellerJoin',
    component: () =>
      import(/* webpackChunkName: "sellerJoin" */ '@/view/seller/sellerJoin')
  },{
    path: '/seller/joinFin',
    name: 'sellerJoinFin',
    component: () =>
      import(/* webpackChunkName: "sellerJoinFin" */ '@/view/seller/sellerJoinFin')
  },{
    path: '/seller/modify',
    name: 'sellerModify',
    component: () =>
      import(/* webpackChunkName: "sellerModify" */ '@/view/seller/sellerModify')
  },
  {
    path: '/seller/sellerList',
    name: 'sellerList',
    component: () =>
      import(/* webpackChunkName: "sellerList" */ '@/view/seller/sellerList')
  },
  {
    path: '/seller/sellerList/:tabState',
    name: 'sellerListTap',
    component: () =>
      import(/* webpackChunkName: "sellerListTap" */ '@/view/seller/sellerList')
  },
  {
    path: '/seller/saleChartDetail/:broadcastSysId/:broadcastScheduleSysId',
    name: 'sellerSaleCharDatail',
    component: () =>
      import(/* webpackChunkName: "sellerSaleCharDatail" */ '@/view/seller/sellerSaleChart')
  },
  {
    path: '/LiveInfo/:broadcastSysId/:broadcastScheduleSysId',
    redirect: (to) => {
      console.log(to);
      const { params } = to
      if (params.broadcastSysId && params.broadcastScheduleSysId) {
        sessionStorage.setItem('liveRedirFlag', 1)
        return {
          path: `/Vod/${params.broadcastSysId}/${params.broadcastScheduleSysId}/live`
        }
      } else {
        return '/404'
      }
    }
  },
  {
    path: '/routeQuery/:routeName/:key/:value',
    redirect: (to) => {
      const { params } = to
      if (params.routeName && params.key && params.value) {
        let query = {
        }

        query[params.key] = params.value

        return {
          name: params.routeName,
          query
        }
      }
      else {
        return '/404'
      }
    }
  },
  {
    path: '/sharePlan',
    name: 'sharePlan',
    component: () =>
      import(/* webpackChunkName: "sharePlan" */ '@/view/event/shareEvent')
  },
  {
    path: '/sharePlan/:userSysId/:date',
    name: 'sharePlanParams',
    component: () =>
      import(/* webpackChunkName: "sharePlan" */ '@/view/event/shareEvent')
  },
  {
    path: '/LiveInfo/share/:broadcastSysId/:broadcastScheduleSysId',
    name: 'liveInfo',
    component: () =>
      import('@/view/liveInfo/LiveInfoMain')
  },
  {
    path: '/LanguageSetting',
    name: 'LanguageSetting',
    component: () =>
      import(/* webpackChunkName: "LanguageSetting" */ '@/view/mypage/LanguageSetting')
  },
  {
    path: '/LiveItems/:type',
    name: 'LiveItems',
    component: () =>
      import(/* webpackChunkName: "LiveItems" */ '@/view/liveInfo/LiveItems')
  },
  {
    path: '/CouponProductsList',
    name: 'CouponProductsList',
    component: () =>
      import(/* webpackChunkName: "CouponProductsList" */ '@/view/ProductDetail/CouponProductsList')
  },
  {
    path: '/404',
    name: 'Not Found',
    component: () =>
      import('@/view/NotFound')
  },
  {
    path: '/Maintenance',
    name: 'Maintenance',
    component: () =>
      import(/* webpackChunkName: "Maintenance" */ '@/view/Maintenance')
  },
  {
    path: '*',
    redirect: '/404'
  }
  ]
}
